// This component will catch network errors and unexpected runtime errors in our React code
// and show the user an appropriate error screen rather than a blank screen.
// It could also be used to log errors to a server within the componentDidCatch method.

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class RootErrorBoundary extends Component {
   constructor(props) {
      super(props);
      this.state = { hasError: false };
   }

   static getDerivedStateFromError(err) {
      const errorType = err.message.match(/^Loading/)
         ? 'Network'
         : 'Unexpected';
      return { hasError: true, errorType, error: err };
   }

   componentDidCatch(error, errorInfo) {
      console.error('RootErrorBoundary caught error:', error);
      console.error('Error info:', errorInfo);
   }

   render() {
      const { hasError, errorType } = this.state;
      const { children } = this.props;
      if (hasError && errorType === 'Network') {
         return <this.props.NetworkErrorScreen />;
      }
      if (hasError && errorType === 'Unexpected') {
         return <this.props.UnexpectedErrorScreen />;
      }

      return children;
   }
}

RootErrorBoundary.propTypes = {
   children: PropTypes.node.isRequired,
};

export { RootErrorBoundary };
